export default __webpack_public_path__ + "static/media/cristiano_ronaldo_2.925dace3.jpg";